import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import { TimelineLite } from 'gsap';

Snappy.Component.RevealEffect = class RevealEffect extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-reveal-effect';
    }

    constructor(element) {
        super(element);

        this.el = element;
        this.options = {
            isContentHidden: true,
            revealSettings: {
                direction: 'rl',
                bgcolor: '#48C2C5',
                duration: 500,
                easing: 'Quint.easeInOut',
                coverArea: 0,
                onCover: function(contentEl, revealerEl) {
                    contentEl.style.opacity = 1;
                },
                onStart: function(contentEl, revealerEl) {
                    return false;
                },
                onComplete: function(contentEl, revealerEl) {
                    return false;
                }
            }
        };
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.layout();
    }

    setVars() {}

    setEventListeners() {}

    layout() {
        let position = getComputedStyle(this.el).position;
        if (position !== 'fixed' && position !== 'absolute' && position !== 'relative') {
            this.el.style.position = 'relative';
        }
        this.content = this.createDOMEl('div', 'block-revealer__content', this.el.innerHTML);
        if (this.options.isContentHidden) {
            this.content.style.opacity = 0;
        }
        this.revealer = this.createDOMEl('div', 'block-revealer__element');
        this.el.classList.add('block-revealer');
        this.el.innerHTML = '';
        this.el.appendChild(this.content);
        this.el.appendChild(this.revealer);

        setTimeout(() => {
            this.startEffect();
        }, 1000);
    }

    getTransformSettings(direction) {
        let val, origin, origin_2;

        switch (direction) {
        case 'lr':
            val = 'scale3d(0,1,1)';
            origin = '0 50%';
            origin_2 = '100% 50%';
            break;
        case 'rl':
            val = 'scale3d(0,1,1)';
            origin = '100% 50%';
            origin_2 = '0 50%';
            break;
        case 'tb':
            val = 'scale3d(1,0,1)';
            origin = '50% 0';
            origin_2 = '50% 100%';
            break;
        case 'bt':
            val = 'scale3d(1,0,1)';
            origin = '50% 100%';
            origin_2 = '50% 0';
            break;
        default:
            val = 'scale3d(0,1,1)';
            origin = '0 50%';
            origin_2 = '100% 50%';
            break;
        }

        return {
            val: val,
            origin: { initial: origin, halfway: origin_2 }
        };
    }

    reveal() {
        this.tween = new TimelineLite();

        if (this.isAnimating) {
            return false;
        }
        this.isAnimating = true;

        const defaults = {
            duration: 500,
            easing: 'easeInOutQuint',
            delay: 0,
            bgcolor: '#f0f0f0',
            direction: 'lr',
            coverArea: 0
        };
        const revealSettings = Object.assign(
            {},
            defaults,
            this.options.revealSettings,
            this.$element.data()
        );
        const direction = revealSettings.direction;
        const transformSettings = this.getTransformSettings(direction);

        this.revealer.style.WebkitTransform = this.revealer.style.transform = transformSettings.val;
        this.revealer.style.WebkitTransformOrigin = this.revealer.style.transformOrigin =
            transformSettings.origin.initial;

        this.revealer.style.backgroundColor = revealSettings.bgcolor;

        this.revealer.style.opacity = 1;

        let self = this,
            animationSettings_2 = {
                complete: function() {
                    self.isAnimating = false;
                    if (typeof revealSettings.onComplete === 'function') {
                        revealSettings.onComplete(self.content, self.revealer);
                    }
                }
            },
            animationSettings = {
                delay: revealSettings.delay,
                complete: function() {
                    self.revealer.style.WebkitTransformOrigin = self.revealer.style.transformOrigin =
                        transformSettings.origin.halfway;
                    if (typeof revealSettings.onCover === 'function') {
                        revealSettings.onCover(self.content, self.revealer);
                    }

                    this.tween2 = new TimelineLite();

                    this.tween2.fromTo(
                        animationSettings_2.targets,
                        animationSettings_2.duration / 1000,
                        {
                            [animationSettings.prop]: 1
                        },
                        {
                            [animationSettings.prop]: coverArea / 100,
                            delay: animationSettings.delay / 1000,
                            ease: animationSettings_2.easing,
                            onComplete: animationSettings_2.complete
                        }
                    );

                    this.tween2.play();
                }
            };

        animationSettings.targets = animationSettings_2.targets = this.revealer;
        animationSettings.duration = animationSettings_2.duration = revealSettings.duration;
        animationSettings.easing = animationSettings_2.easing = revealSettings.easing;

        var coverArea = revealSettings.coverArea;
        if (direction === 'lr' || direction === 'rl') {
            animationSettings.prop = 'scaleX';
        } else {
            animationSettings.prop = 'scaleY';
        }

        if (typeof revealSettings.onStart === 'function') {
            revealSettings.onStart(self.content, self.revealer);
        }

        this.tween.to(animationSettings.targets, animationSettings.duration / 1000, {
            [animationSettings.prop]: 1,
            delay: animationSettings.delay / 1000,
            ease: animationSettings.easing,
            onComplete: animationSettings.complete
        });
        this.tween.play();

        //anime(animationSettings);
    }

    createDOMEl(type, className, content) {
        var el = document.createElement(type);
        el.className = className || '';
        el.innerHTML = content || '';
        return el;
    }

    startEffect() {
        if ('requestIdleCallback' in window) {
            requestIdleCallback(() => this.reveal(), { timeout: 1500 });
        } else {
            setTimeout(() => {
                this.reveal();
            }, 100);
        }
    }
};



// WEBPACK FOOTER //
// ./components/revealEffect/scripts/revealEffect.js